import { createSelector } from '@reduxjs/toolkit'

import { selectMarketYoyGrowthExpectationState } from './selectMarketYoyGrowthExpectationState'

/** The full offering/category reference hierarchy, independent of `records`. */
export const selectMarketYoyGrowthExpectationCategories = createSelector(
  [selectMarketYoyGrowthExpectationState],
  (state) => state.categories
)
